import { render, staticRenderFns } from "./AffiliateInvoicePage.vue?vue&type=template&id=2ea69150&scoped=true&"
import script from "./AffiliateInvoicePage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateInvoicePage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateInvoicePage.vue?vue&type=style&index=0&id=2ea69150&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea69150",
  null
  
)

export default component.exports